import eventBus from './src/eventBus'
import promisePro from './src/promisePro'

export default (vue) => {
	promisePro()
	vue.prototype.$fxEventBus = eventBus
}



// WEBPACK FOOTER //
// ./src/lib/plugin/index.js